import { useCallback } from 'react';
import { useAnimationControls } from 'framer-motion';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';

const usePositionUpdater = (
  actions: HTMLDivElement,
  actionsWidth: number,
  actionsInnerWidth: number,
  animationControls: ReturnType<typeof useAnimationControls>,
) => {
  const findActionActive = useCallback((url: string|undefined): HTMLElement => {
    let actionActiveSelector = `.${AdvertListFilterControlsCss.advertListFilterControls__action_active}`;
    if (url) {
      actionActiveSelector = `.${AdvertListFilterControlsCss.advertListFilterControls__action}[data-url="${url}"]`;
    }

    return actions.querySelector<HTMLDivElement>(actionActiveSelector);
  }, [actions]);

  const calculateX = useCallback((url: string|undefined, actionActive: HTMLElement): number => {
    let x = (actionsWidth / 2) - actionActive.offsetLeft;
    if (actionsInnerWidth <= Math.abs(x - actionsWidth)) {
      x = -(actionsInnerWidth - actionsWidth);
    }
    if (url && x > 0) {
      x = 0;
    }

    return x;
  }, [actionsInnerWidth, actionsWidth]);

  const update = useCallback((url: string = undefined): void => {
    const actionActive = findActionActive(url);

    if (!actionActive) {
      return;
    }

    const x = calculateX(url, actionActive);
    if (!url && (x > 0 || actionsWidth >= actionActive.offsetLeft)) {
      return;
    }

    animationControls.start({
      x,
      transition: { duration: 0 },
    }).then();
  }, [actionsWidth, animationControls, calculateX, findActionActive]);

  return { update };
};

export { usePositionUpdater };
